import React from 'react'
import { AlertOutlined } from "@ant-design/icons";
import { Button, Empty } from 'antd';
import {NoData} from "../../Utils/imports"

const NoDataFound = ({ component }) => {

    // let message = "No Data";
    // if (component === "HomeAlerts") {
    //   message = "No Alerts";
    // }

    return (
        <div className='noData-Container dflex justifyCenter alignCenter'>
            {/* <h2>No Data <AlertOutlined style={{ marginLeft: '10px', fontSize: '30px' }} /></h2> */}
            <img src={NoData} alt="" />
            <h3 className="noData-Text">No Data</h3>
            {/* <Button onClick={() => window.location.reload()} style={{ borderRadius: "10px" }} >Reload Page</Button> */}
        </div>
    )
}

export default NoDataFound